<template>
    <span
        @focus="focused = true"
        @blur="focused = false"
        class="relative inline-flex items-center justify-center flex-shrink-0 w-10 h-5 rounded-full cursor-pointer focus:outline-none"
        role="checkbox"
        :class="{
            'bg-blue-600 ': value,
            'bg-gray-700': !value
        }"
        tabindex="0"
        @click="toggle()"
        @keydown.space.prevent="toggle()"
        :aria-checked="value.toString()"
    >
        <span
            aria-hidden="true"
            class="absolute h-4 mx-auto transition-colors duration-200 ease-in-out rounded-full w-9"
            :class="{ 'bg-blue-600': value, 'bg-gray-100': !value }"
        ></span>
        <span
            aria-hidden="true"
            :class="{
                'translate-x-5 ': value,
                'translate-x-0 ': !value,
                'shadow-outline border-blue-300': focused
            }"
            class="absolute left-0 inline-block w-5 h-5 transition-transform duration-200 ease-in-out transform bg-white rounded-full shadow"
        ></span>
    </span>
</template>

<script>
export default {
    props: {
        triggered: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            value: this.triggered,
            focused: false
        };
    },
    methods: {
        toggle() {
            this.value = !this.value;
            this.$emit("toggleTriggered", this.value);
        }
    }
};
</script>

<style></style>
